/*
 * @FilePath: \kitchen-online-web\src\redux\reducers\size.js
 * @Author: Yu Wang
 * @Date: 2021-07-29 19:19:37
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-10 23:35:52
 * @LastEditTime: 2022-05-18 13:44:14
 */
const sizeAction = {
  add: (state, payload) => ({ count: payload.count + state.count }),
  setSize: (state, payload) => ({
    size: {
      ...payload.size,
      ...state.size,
    },
    ...state,
  }),
  sizeUnderId: (state, payload) => ({
    ...state,
    sizeUnder: {
      ...payload,
    },
  }),
  lenId: (state, payload) => ({
    ...state,
    lenUnder: {
      ...payload,
    },
  }),
  TopLenId: (state, payload) => ({
    ...state,
    lenTop: {
      ...payload,
    },
  }),
  highId: (state, payload) => ({
    ...state,
    highUnder: payload,
  }),
  sizeTopId: (state, payload) => ({
    ...state,
    sizeTop: {
      ...payload,
    },
  }),
  topHighId: (state, payload) => ({
    ...state,
    TophighUnder: payload,
  }),
  setUnderLength: (state, payload) => ({
    ...state,
    lengthVal: Object.assign([], { ...state.lengthVal, ...payload }),
    // lengthVal: payload,
  }),
  setTopLength: (state, payload) => ({
    ...state,
    lengthTopVal: Object.assign([], { ...state.lengthTopVal, ...payload }),
    // lengthTopVal: payload,
  }),
  renderEngine: (state, payload) => ({
    ...state,
    renderEngine: payload,
  }),
  getStepDetail: (state, payload) => ({ // 清单数据
    ...state,
    getStepDetail: payload,
  }),
  TemporaryDetail: (state, payload) => ({ // 暂存的清单数据
    ...state,
    TemporaryDetail: payload,
  }),
  backFromSize: (state, payload) => ({ // 暂存的清单数据
    ...state,
    backFromSize: payload,
  }),
  oldTempleteJson: (state, payload) => ({ // 暂存的清单数据
    ...state,
    oldTempleteJson: payload,
  }),
  showLoading: (state, payload) => ({
    ...state,
    showLoading: payload,
  }),

  // version2.0
  setHasTopCabinet: (state, payload) => ({
    ...state,
    hasTopCabinet: payload,
  }),

  'set-under-length': (state, payload) => (
    {
      ...state,
      lengthVal: [...payload],
      // lengthVal: payload,
    }
  ),
  'set-top-length': (state, payload) => (
    {
      ...state,
      lengthTopVal: [...payload],
      // lengthVal: payload,
    }
  ),
  'set-length': (state, payload) => (
    {
      ...state,
      lengthVal: [...payload.under],
      lengthTopVal: [...payload.top],
    }
  ),
  setLocation: (state, payload) => (
    {
      ...state,
      location: {
        ...state.location,
        ...payload,
      },
    }
  ),
  sizeSign: (state, payload) => ({ // 当尺寸修改弹窗关闭时为true
    ...state,
    sizeSign: payload,
  }),
  refrigerId: (state, payload) => ({
    ...state,
    refrigerId: payload,
  }),
  refrigerType: (state, payload) => ({
    ...state,
    refrigerType: payload,
  }),
  LImageReversal: (state, payload) => ({ // L型底柜图片是否展示尺寸交换后的图
    ...state,
    LImageReversal: payload,
  }),
  showInitLoading: (state, payload) => ({
    ...state,
    showInitLoading: payload,
  }),
  isHighlowCabinet: (state, payload) => ({
    ...state,
    isHighlowCabinet: payload,
  }),
  isChangeTopTips: (state, payload) => ({
    ...state,
    isChangeTopTips: payload,
  }), // 更改顶柜位置tips
  isSeat: (state, payload) => ({
    ...state,
    isSeat: payload,
  }), // 更改顶柜位置左中右
  featLeft: (state, payload) => ({
    ...state,
    featLeft: payload,
  }), // 顶柜换边按钮到左侧的距离
  isChangeApi: (state, payload) => ({
    ...state,
    isChangeApi: payload,
  }),
};
export default sizeAction;
